import {
  Button,
  ButtonGroup,
  Divider,
  DrawerBody,
  Flex,
  Heading,
  Select,
  Stack,
  Text,
} from '@chakra-ui/react';
import { ContractModalFooter } from '../../../molecules';
import { useChangePlanModalContext } from '../ModalContext';
import CurrentPlan from './CurrentPlan';

interface ChangePlanModalSelectionProps {
  onClose(): void;
}

const Services: React.FC<ChangePlanModalSelectionProps> = ({ onClose }) => {
  const {
    nextStep,
    selectedPlan,
    setSelectedPlan,
    periodicity,
    setPeriodicity,
    plan,
    availableServices,
  } = useChangePlanModalContext();

  return (
    <Flex direction="column" h="100%" justify="space-between" px={4}>
      <DrawerBody scrollBehavior="auto">
        <Stack py="1rem" minH="100%">
          <CurrentPlan />

          <Divider my="1rem" />

          <Heading size="md" fontWeight={'semibold'} mb="1rem">
            Qual vai ser a nova periodicidade?
          </Heading>

          <Heading size="sm" fontWeight={'medium'} mb="0.5rem">
            Nova periodicidade
          </Heading>

          <ButtonGroup isAttached>
            <Button
              onClick={() => setPeriodicity('monthly')}
              colorScheme={periodicity === 'monthly' ? 'yooga' : 'gray'}
              isDisabled={true}
              w="6rem"
            >
              Mensal
            </Button>
            <Button
              onClick={() => setPeriodicity('yearly')}
              colorScheme={periodicity === 'yearly' ? 'yooga' : 'gray'}
              w="6rem"
            >
              Anual
            </Button>
          </ButtonGroup>

          <Text variant="label">
            Por enquanto, não é possível realizar a troca para periodicidade
            mensal
          </Text>

          <Divider m="0.5rem 0 1rem" />

          <Heading size="md" fontWeight={'semibold'} mb="1rem">
            Qual vai ser o novo plano?
          </Heading>

          <Heading size="sm" fontWeight={'medium'} mb="0.5rem">
            Novo plano
          </Heading>

          <Select
            value={selectedPlan}
            onChange={(e) => setSelectedPlan(Number(e.target.value))}
          >
            <option disabled value="-1">
              Selecione um plano
            </option>
            {availableServices.map((service) => (
              <option
                key={service.id}
                value={service.id}
                disabled={plan?.id === service.id}
              >
                {service.name} - {service.priceString}
              </option>
            ))}
          </Select>
        </Stack>
      </DrawerBody>

      <ContractModalFooter
        onCancel={onClose}
        onNext={nextStep}
        isNextDisabled={!selectedPlan}
      />
    </Flex>
  );
};

export default Services;
